import React, { useCallback, useContext, useEffect, useState } from 'react'
import { FormInput } from '../../components/FormInput';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Tooltip } from 'primereact/tooltip';
import { F1020102Before, getPersonalInfo, updatePersonalInfo } from '../../utility/service/personal-service';
import { checkDpSuccess, getIdpType, writeToken } from '../../utility/service/tool-service';
import { MessageContext,handleSuccessMessage } from '../../store/messageStore'; 
import { AcctContext } from '../../utility/useReduce/userNameReduce';
import { addFormValidator } from '../../utility/validate/formValidator';
import { MaskedFormInput } from '../../components/MaskedFormInput';
import { useFuncId } from '../../router/menuRouterMapper';
import { updateAuditEyesEvent } from '../../utility/service/audilog-service';
import { useEditableFlag } from '../../hooks/useEditableFlag';

const PersonalProfile = () => {
    const { t } = useTranslation();
    const [, dispatch] = useContext(MessageContext); //訊息視窗
    const [state, dispatchUser] = useContext(AcctContext); //訊息視窗 
    const [readonly, setReadonly] = useState(true);
    const [personalInfo,setPersonalInfo] = useState({});
    const [formRule, setFormRule] = useState([]); //表單驗證
    const [maskView,setMaskView]=useState(false);
    const chsFuncId = useFuncId();
    const isEditable = useEditableFlag('F10201'); // 使用正確的功能 ID：F10201

    

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        reset,
        formState: { errors, isValid, isDirty }
    } = useForm({
        defaultValues: {
            acct: '',
            name: '',
            // phone: "",
            email: '',
            roleName: "",
            agreeMarketing: false
        },
        //錯誤驗證時機
        mode: "all"
    });

    const axios_getPersonalInfo = ()=>{
        getPersonalInfo()
        .then((res)=>{
            if(checkDpSuccess(res)){
                let data = res.data.RespBody;
                setPersonalInfo(data);
                setValue("acct",data.acct);
                setValue("name",data.name);
                // setValue("phone",data.phone);
                setValue("email",data.email);
                setValue("roleName",data.roleName);
                setValue("agreeMarketing", data.agreeMarketing === 'Y');
            }
        })
    }

    useEffect(()=>{
        axios_getCreateBefore();//統一檢核
        //取得使用者資訊
        axios_getPersonalInfo();
    },[])

    //建立前查詢form 規則
    const axios_getCreateBefore = ()=>{
        F1020102Before()
            .then((res)=>{
                if(checkDpSuccess(res)){
                    let array = []
                    res?.data?.RespBody?.constraints?.forEach((item) => {
                        const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                        array.push(result)
                    })
                    setFormRule(array);
                }
            })
        }

    const setValidForm = useCallback((formId) => {
        if (formRule?.length > 0) {
            const tmp = formRule?.find((item) => {
                return Object.keys(item)[0] === formId
            });
            return tmp ? tmp[formId] : '';
        }
    }, [formRule]);


    const onSubmit = (data) => {
        let reqBody = {
            name:data.name,
            // phone:data.phone,
            email:data.email,
            agreeMarketing: data.agreeMarketing ? 'Y' : 'N'
        }
        updatePersonalInfo(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    handleSuccessMessage(dispatch, t('button.update') +' '+ t('message.success'));
                    writeToken("userName",data.name);
                    dispatchUser({ type: 'CHANGE_NAME', payload: data.name });
                    setMaskView(false);
                    axios_getPersonalInfo();
                }
            })
            setReadonly(true);
    }

    const handleBtnCancel = () => {
        setValue("name", personalInfo?.name, { shouldValidate: true });
        // setValue("phone", personalInfo?.phone, { shouldValidate: true });
        setValue("email", personalInfo?.email, { shouldValidate: true });
        setValue("agreeMarketing", personalInfo?.agreeMarketing === 'Y', { shouldValidate: true });
    }

    const handleMaskClick = ()=>{
        setMaskView(prev => {
            return !prev;
          });
    }

    const axios_updateAuditEyesEvent = ()=>{
        updateAuditEyesEvent({
            functionId:chsFuncId,
            eventType:"E"
        })
        .then((res)=>{
            if(checkDpSuccess(res)){

            }
        })
    }

    return (
        <>
            <div className='p-card'>
                <div className='p-card-body'>
                    <form onSubmit={handleSubmit(onSubmit)} className="grid">
                        <div className="col-12 lg:col-6">
                            {/* <FormInput
                                register={register}
                                errors={errors}
                                id="acct"
                                name="acct"
                                type="text"
                                labelText={t('account')}
                                labelClass="control-label"
                                disabled={true}
                                /> */}
                              <Controller
                                name="acct"
                                control={control}
                                render={({ field, fieldState }) => (
                                    <MaskedFormInput
                                    {...field}
                                    type="text"
                                    labelClass={`${readonly === false ? 'required' : ''}`}
                                    labelText={t('account')}
                                    maskType="account"
                                    maskView={maskView}
                                    setMaskView={() => handleMaskClick()}
                                    disabled={true}
                                    errorMessage={fieldState.error?.message}
                                    />
                                )}
                                />    
                        </div>
                        <div className="col-12 lg:col-6">
                            {/* <FormInput
                                register={register}
                                errors={errors}
                                id="name"
                                name="name"
                                type="text"
                                labelText={t('user_name')}
                                labelClass={`${readonly === false ? 'required' : ''}`}
                                disabled={readonly}
                                rules={setValidForm("name")}
                            /> */}
                            <Controller
                                name="name"
                                control={control}
                                rules={setValidForm("name")}
                                render={({ field, fieldState }) => (
                                    <MaskedFormInput
                                    {...field}
                                    type="text"
                                    labelClass={`${readonly === false ? 'required' : ''}`}
                                    labelText={t('user_name')}
                                    maskType="username"
                                    maskView={maskView}
                                    setMaskView={() => handleMaskClick()}
                                    disabled={readonly}
                                    errorMessage={fieldState.error?.message}
                                    />
                                )}
                                />
                        </div>
                        {/* <div className="col-12 lg:col-6">
                            <FormInput
                                register={register}
                                errors={errors}
                                id="phone"
                                name="phone"
                                type="tel"
                                labelText={t('tel')}
                                placeholder="09XXXXXXXX"
                                labelClass={`${readonly === false ? 'required' : ''}`}
                                rules={setValidForm("phone")}
                                disabled={readonly}
                            />
                        </div> */}
                        <div className="col-12 lg:col-6">
                            {/* <FormInput
                                register={register}
                                errors={errors}
                                id="email"
                                name="email"
                                type="text"
                                labelText={t('user_email')}
                                labelClass={`${readonly === false ? 'required' : ''}`}
                                disabled={readonly || getIdpType()==='GOOGLE'}
                                rules={setValidForm("email")}
                            /> */}
                                <Controller
                                name="email"
                                control={control}
                                rules={setValidForm("email")}
                                render={({ field, fieldState }) => (
                                    <MaskedFormInput
                                    {...field}
                                    type="text"
                                    labelClass={`${readonly === false ? 'required' : ''}`}
                                    labelText={t('user_email')}
                                    maskType="email"
                                    maskView={maskView}
                                    setMaskView={() => handleMaskClick()}
                                    disabled={readonly}
                                    errorMessage={fieldState.error?.message}
                                    />
                                )}
                                />
                        </div>

                        <div className="col-12 lg:col-6">
                            <FormInput
                                register={register}
                                errors={errors}
                                id="roleName"
                                name="roleName"
                                type="text"
                                labelText={t('role')}
                                labelClass="control-label"
                                disabled={true}
                            />
                        </div>

                        <div className="col-12">
                            <Tooltip target=".marketing-info-icon-profile" position="top" style={{ maxWidth: '320px' }} />
                            <div className="flex align-items-center gap-2">
                                <Checkbox
                                    inputId="agreeMarketing"
                                    checked={watch('agreeMarketing')}
                                    onChange={(e) => setValue('agreeMarketing', e.checked, { shouldDirty: true })}
                                    disabled={readonly}
                                />
                                <label
                                    htmlFor="agreeMarketing"
                                    style={{ fontSize: '14px', cursor: readonly ? 'default' : 'pointer', marginBottom: 0 }}
                                >
                                    {t('agree_marketing')}
                                </label>
                                <i
                                    className="pi pi-info-circle marketing-info-icon-profile"
                                    data-pr-tooltip={t('agree_marketing_detail')}
                                    style={{ fontSize: '14px', cursor: 'pointer', color: '#6c757d' }}
                                />
                            </div>
                        </div>

                        {/* Button替換區 */}
                        <div className="col-12 gap-2 flex-all-center">
                            {
                                readonly === true ? (
                                    <Button 
                                        label={t("button.edit")} 
                                        disabled={!isEditable}
                                        onClick={(e) => { 
                                            e.preventDefault(); 
                                            setReadonly(false);
                                            setMaskView(true);
                                            axios_updateAuditEyesEvent();
                                        }} 
                                        size="small" 
                                    />
                                ) : (
                                    <>
                                        <Button disabled={!isValid} type="submit" label={t("button.confirm")} size="small" />
                                        <Button outlined size="small" label={t("button.cancel")} onClick={(e) => {
                                            e.preventDefault();
                                            handleBtnCancel();
                                            setReadonly(true);
                                            setMaskView(false);
                                            axios_getPersonalInfo();
                                        }} />


                                    </>
                                )
                            }
                        </div>

                    </form>
                </div>
            </div>
        </>
    )
}

export default PersonalProfile;